import { delay } from 'base/helpers';
import { globalSuggestionsStore, Suggestion } from '../suggested_edits';

export type RemoveSingleSuggestion = (opts?: { delayMs?: number }) => void;

/** A wrapper around suggestedEditsStore that only lets the last suggestion be set */
export class SingleSuggestionStore {
  private current:
    | { value: Suggestion | (() => Suggestion); removeNow(): void }
    | undefined;

  set(value: Suggestion | (() => Suggestion)): RemoveSingleSuggestion {
    if (this.current) this.current.removeNow();
    const removeNow = globalSuggestionsStore.add(value);
    const me = { value, removeNow };
    this.current = me;
    return async ({ delayMs = 0 } = {}) => {
      if (delayMs > 0) {
        if (this.current !== me) return; // don't wastefully delay
        await delay(delayMs);
      }
      if (this.current !== me) return;
      this.clear();
    };
  }

  clear() {
    this.current?.removeNow();
    this.current = undefined;
  }
}
